import React from 'react';
/**
 * Use this with caution as it is a hack.
 *
 * Essentially we want to have a callback which has the entire current state/props,
 * and not only the deps, but the identity of the callback itself doesn't change,
 * making it safe to send downstream and not cause re-renders.
 */

function useEventCallback(fn) {
  var ref = React.useRef();
  React.useLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(undefined, args);
  }, []);
}

export default useEventCallback;